import { render, staticRenderFns } from "./DiagnosticTestIcon.vue?vue&type=template&id=5046d94c&scoped=true"
import script from "./DiagnosticTestIcon.vue?vue&type=script&lang=js"
export * from "./DiagnosticTestIcon.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticTestIcon.vue?vue&type=style&index=0&id=5046d94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5046d94c",
  null
  
)

export default component.exports